import {
  useEntity,
  EntityRefLinks,
} from '@backstage/plugin-catalog-react';
import { Grid } from '@material-ui/core';
import { InfoCard, MarkdownContent } from '@backstage/core-components';
import { AboutField } from '@backstage/plugin-catalog';
import { parseEntityRef } from '@backstage/catalog-model';
import {
  AWS_ACCOUNT_NUMBER_ANNOTATION,
  AWS_MANAGER_NAME_ANNOTATION,
  AWS_OWNER_NAME_ANNOTATION,
} from '@internal/plugin-homestead-constants-common';

export const AwsAccountAboutCard = () => {
  const { entity } = useEntity();

  const manager =
    entity?.metadata?.annotations?.[AWS_MANAGER_NAME_ANNOTATION] || 'Unknown';
  const owner =
    entity?.metadata?.annotations?.[AWS_OWNER_NAME_ANNOTATION] || 'Unknown';
  const description = entity?.metadata?.description || 'No description found';
  const accountNumber =
    entity?.metadata?.annotations?.[AWS_ACCOUNT_NUMBER_ANNOTATION] || 'Unknown';
  const managedByRelations = manager ? [parseEntityRef(`user:${manager}`)] : [];
  const ownedByRelations = owner ? [parseEntityRef(`user:${owner}`)] : [];

  return (
    <InfoCard title="Account Details">
      <Grid spacing={2} container>
        <Grid item xs={12} sm={4}>
          <AboutField
        label="Account Number"
        value={accountNumber}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <AboutField
        label="Account Owner"
        value="Unknown"
          >
        {ownedByRelations.length > 0 && (
          <EntityRefLinks
            entityRefs={ownedByRelations}
            defaultKind="user"
          />
        )}
          </AboutField>
        </Grid>

        <Grid item xs={12} sm={4}>
          <AboutField
        label="Account Manager"
        value=""
          >
        {managedByRelations.length > 0 && (
          <EntityRefLinks
            entityRefs={managedByRelations}
            defaultKind="user"
          />
        )}
          </AboutField>
        </Grid>

        <Grid item xs={12}>
          <AboutField label="Description">
        <MarkdownContent content={description} />
          </AboutField>
        </Grid>
      </Grid>
    </InfoCard>
  );
};
